angular
    .module('app')
    .component('campaignsList', {
        templateUrl: '/templates/pages/campaigns/campaignsList/campaignsList.html',
        controller: 'CampaignsListController',
        controllerAs: 'vm',
    });